<mat-nav-list>
  <ng-container >
    <mat-list-item>
      <a mat-menu-item [routerLink]="'/admin/dashboard'">
        <mat-icon>dashboard</mat-icon>
        <span>Dashboard</span>
      </a>
    </mat-list-item>
    <mat-list-item>
      <a mat-menu-item [routerLink]="'/admin/user-list'">
        <mat-icon>group</mat-icon>
        <span>Manage Users</span>
      </a>
    </mat-list-item>
    <mat-list-item>
      <a mat-menu-item [routerLink]="'/admin/pet-listings'">
        <mat-icon>pets</mat-icon>
        <span>Manage Pets</span>
      </a>
    </mat-list-item>
    <mat-list-item>
      <a mat-menu-item [routerLink]="'/admin/categories'">
        <mat-icon>category</mat-icon>
        <span>Manage Categories</span>
      </a>
    </mat-list-item>
    <mat-list-item>
      <a mat-menu-item [routerLink]="'/admin/breeds'">
        <mat-icon>pets</mat-icon>
        <span>Manage Breeds</span>
      </a>
    </mat-list-item>
    <mat-list-item>
      <a mat-menu-item [routerLink]="'/admin/relocation-areas'">
        <mat-icon>place</mat-icon>
        <span>Relocation Areas</span>
      </a>
    </mat-list-item>
    <mat-list-item>
      <a mat-menu-item [routerLink]="'/admin/contact-messages'">
        <mat-icon>mail</mat-icon>
        <span>Manage Messages</span>
      </a>
    </mat-list-item>
    <mat-list-item>
      <a mat-menu-item [routerLink]="'/admin/email-campaign'">
        <mat-icon>campaign</mat-icon>
        <span>Email Campaigns</span>
      </a>
    </mat-list-item>
    <mat-list-item>
      <a mat-menu-item [routerLink]="'/admin/whatsapp-campaign'" title="WhatsApp & SMS Campaigns">
        <mat-icon>message</mat-icon>
        <span>WhatsApp & SMS</span>
      </a>
    </mat-list-item>
    <mat-list-item>
      <a mat-menu-item [routerLink]="'/admin/template-management'" title="Manage WhatsApp & SMS Templates">
        <mat-icon>edit_note</mat-icon>
        <span>Manage Templates</span>
      </a>
    </mat-list-item>
    <mat-list-item>
      <a mat-menu-item [routerLink]="'/admin/orders'">
        <mat-icon>assignment</mat-icon>
        <span>Adoption Requests</span>
      </a>
    </mat-list-item>
    <mat-list-item>
      <a mat-menu-item [routerLink]="'/admin/user-migration'">
        <mat-icon>report</mat-icon>
        <span>User Migration</span>
      </a>
    </mat-list-item>
    <mat-list-item>
      <a mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
      </a>
    </mat-list-item>
  </ng-container>
  <!-- <ng-template #userMenu>
    <mat-list-item>
      <a mat-menu-item [routerLink]="['/dashboard']">
        <mat-icon>home</mat-icon>
        <span *ngIf="!isMobileScreen">Home</span>
      </a>
    </mat-list-item>
    <mat-list-item>
      <a mat-menu-item [routerLink]="['/customer']">
        <mat-icon>menu</mat-icon>
        <span *ngIf="!isMobileScreen">Categories</span>
      </a>
    </mat-list-item>
    <mat-list-item>
      <a mat-menu-item [routerLink]="['/chat']">
        <mat-icon>chat</mat-icon>
        <span *ngIf="!isMobileScreen">Chat</span>
      </a>
    </mat-list-item>
    <mat-list-item>
      <a mat-menu-item [routerLink]="['/settings']">
        <mat-icon>settings</mat-icon>
        <span *ngIf="!isMobileScreen">Settings</span>
      </a>
    </mat-list-item>
  </ng-template> -->
  <mat-divider></mat-divider>
  <!-- <mat-list-item>
    <a mat-menu-item [routerLink]="['/contact']">
      <mat-icon>phone</mat-icon>
      <span *ngIf="!isMobileScreen">Contact Us</span>
    </a>
  </mat-list-item> -->
</mat-nav-list>